export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  props?: Partial<{ className: string; text: string; title: string; type: string; }>,
  children: Array<Node | null> = []
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  if (props?.className) node.className = props.className;
  if (props?.text != null) node.textContent = props.text;
  if (props?.title != null) node.title = props.title;
  if (props?.type != null && node instanceof HTMLInputElement) node.type = props.type;
  for (const c of children) if (c) node.appendChild(c);
  return node;
}

export function replace(host: HTMLElement, ...children: Array<Node | null>): void {
  host.replaceChildren(...children.filter((c): c is Node => c !== null));
}
